import React, { useEffect, useState } from "react";
import { fetchChildrenUsers } from "../../../../services/reportsDataService";
import { styled, Typography } from "@mui/material";
import CompactCheckboxDropdown, {
  Option,
} from "./ReplEdititingFilters/CompactCheckboxDropdown";

interface SalesManFilterProps {
  value: string[];
  options: Option[];
  onChange: (value: string[]) => void;
  loading?: boolean;
  onOpen?: () => void;
}
interface Props {
  name: string;
  values: any;
  setValues: React.Dispatch<React.SetStateAction<any>>;
}

const SalesManFilter: React.FC<SalesManFilterProps> = ({
  value,
  options,
  onChange,
  loading,
  onOpen,
}) => {
  return (
    <CompactCheckboxDropdown
      label="Select Salesmen"
      options={options}
      selectedValues={Array.isArray(value) ? value : []}
      onChange={onChange}
      placeholder="Select Salesmen"
      width={200}
      loading={loading}
      enableSelectAll
      selectAllLabel="Select All Salesmen"
      onOpen={onOpen}
    />
  );
};

const SalesManTypeFilter = (props: Props) => {
  const [salesManOptions, setSalesManOptions] = useState<any>([]);
  const [salesManLoading, setSalesManLoading] = useState<boolean>(false);
  const [filters, setFilters] = useState<any>({});
  const handleSalesManChange = (values: string[]) => {
    setFilters((prev: any) => ({
      ...prev,
      salesman: values,
    }));
    props.setValues({
      ...props.values,
      ["salesmen"]: {
        ...props.values?.["salesmen"],
        value: values,
      },
    });
  };
  useEffect(() => {
    props.setValues({
      ...props.values,
      ["salesmen"]: {
        ...props.values?.["salesmen"],
        value: [],
      },
    });
    setFilters([]);
    setSalesManOptions([]);
  }, [props.values?.["distributor"]?.value]);

  const fetchSalesman = async () => {
    if (!props.values?.["distributor"]?.value) return;
    setSalesManLoading(true);
    try {
      const distributors = props.values?.distributor?.value ?? [];
      const responses = await Promise.all(
        distributors.map((dist: string) => fetchChildrenUsers(dist, "salesman"))
      );

      const uniqueSalesmen = Array.from(
        new Set(responses.flat().filter(Boolean))
      );

      setSalesManOptions(
        uniqueSalesmen.map((item) => ({
          label: item,
          value: item,
        }))
      );
    } catch (err) {
      console.error("Error fetching salesmen", err);
    } finally {
      setSalesManLoading(false);
    }
  };

  const Wrapper = styled("div")(`
    font-size:15px;
    text-align:left;
    padding-left:0.2rem;
    font-weight:500;
   margin-bottom: 8px;
    
    &::first-letter {
    text-transform: capitalize;
    }
  `);

  return (
    <>
      <Wrapper>
        Please select the Salesmen
        <Typography
          component="span"
          sx={{ color: "red", ml: "4px", mr: "4px" }}
        >
          *
        </Typography>
      </Wrapper>
      <SalesManFilter
        value={filters?.salesman ?? []}
        options={salesManOptions}
        onChange={(values) => {
          handleSalesManChange(values);
        }}
        loading={salesManLoading}
        onOpen={fetchSalesman}
      />
    </>
  );
};

export default SalesManTypeFilter;
